import { useEffect } from 'react';

var usePageLeave = function usePageLeave(onPageLeave, args) {
  if (args === void 0) {
    args = [];
  }

  useEffect(function () {
    if (!onPageLeave) {
      return;
    }

    var handler = function handler(event) {
      event = event ? event : window.event;
      var from = event.relatedTarget || event.toElement;

      if (!from || from.nodeName === 'HTML') {
        onPageLeave();
      }
    };

    document.addEventListener('mouseout', handler);
    return function () {
      document.removeEventListener('mouseout', handler);
    };
  }, args);
};

export default usePageLeave;